var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.name))]),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.value))])],1)],1),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }